<table role="grid" aria-labelledby="{{::uniqueId}}-title" aria-activedescendant="{{activeDateId}}" class="dp-table dpt-day">
    <thead>
        <tr class="tr-dpnav">
              <th><button type="button" class="pull-left btn-dp" ng-click="move(-1)" tabindex="-1"><i class="zmdi zmdi-long-arrow-left"></i></button></th>
              <th colspan="{{::5 + showWeeks}}">
                  <button id="{{::uniqueId}}-title" role="heading" aria-live="assertive" aria-atomic="true" type="button" ng-click="toggleMode()" ng-disabled="datepickerMode === maxMode" tabindex="-1" class="w-100 btn-dp"><div class="dp-title">{{title}}</div></button>
            </th>
              <th><button type="button" class="pull-right btn-dp" ng-click="move(1)" tabindex="-1"><i class="zmdi zmdi-long-arrow-right"></i></button></th>
        </tr>
        <tr class="tr-dpday">
              <th ng-if="showWeeks" class="text-center"></th>
              <th ng-repeat="label in ::labels track by $index" class="text-center padding-calendar" ><small aria-label="{{::label.full}}">{{::label.abbr}}</small></th>
        </tr>
    </thead>
    <tbody>
        <tr ng-repeat="row in rows track by $index">
              <td ng-if="showWeeks" class="text-center h6"><em>{{ weekNumbers[$index] }}</em></td>
              <td ng-repeat="dt in row track by dt.date" class="text-center" role="gridcell" id="{{::dt.uid}}" ng-class="::dt.customClass">
                    <button type="button" class="w-100 btn-dp btn-dpday btn-dpbody" ng-class="{'dp-today': dt.current, 'dp-selected': dt.selected, 'dp-active': isActive(dt)}" ng-click="select(dt.date)" ng-disabled="dt.disabled" tabindex="-1"><span ng-class="::{'dp-day-muted': dt.secondary, 'dp-day-today': dt.current}">{{::dt.label}}</span></button>
              </td>
        </tr>
    </tbody>
</table>
